import { getMomentTz } from "@dexteel/mesf-core";
import { SectionRevisions } from "./templateDrafts";
import { TemplateIssue } from "./templateValidation";

const moment = getMomentTz();

export const asDay = (date: Date) => moment(date).format("MM/DD/YYYY");

const between = (what: string, low: string | null, high: string | null) =>
	low !== null && high !== null
		? `${what} is written between ${low} and ${high}.`
		: low !== null
			? `${what} is written after ${low}.`
			: `${what} is written before ${high}.`;

export const describeIssue = (issue: TemplateIssue): string => {
	switch (issue.kind) {
		case "rev-taken":
			return `Rev ${issue.rev} is already registered for this section. Every revision keeps the readings taken under it, so it cannot be written over.`;

		case "rev-behind":
			return `Rev ${issue.rev} is behind Rev ${issue.highest}, which this section already spent. A revision is written past the last one, never before it.`;

		case "rev-out-of-order":
			return between(
				`Rev ${issue.rev} would move this revision out of order: it`,
				issue.before === null ? null : `Rev ${issue.before.Rev}`,
				issue.after === null ? null : `Rev ${issue.after.Rev}`,
			);

		case "effective-before-latest":
			return `Rev ${issue.rev} takes over on ${asDay(issue.takesOverOn)}, so a revision written after it cannot start earlier.`;

		case "effective-out-of-order":
			return between(
				"This revision takes over out of order: it",
				issue.before?.EffectiveFrom == null
					? null
					: `Rev ${issue.before.Rev} on ${asDay(issue.before.EffectiveFrom)}`,
				issue.after?.EffectiveFrom == null
					? null
					: `Rev ${issue.after.Rev} on ${asDay(issue.after.EffectiveFrom)}`,
			);
	}
};

export const newRevMessage = (
	revisions: SectionRevisions,
	rev: number | null,
) => {
	if (rev === null) return null;

	if (revisions.isTaken(rev, null))
		return `Rev ${rev} is already registered for this section`;

	if (revisions.isBehind(rev))
		return `Rev ${rev} is behind Rev ${revisions.highest}, which this section already spent`;

	return null;
};
